import UIConstants from '../constants/UIConstants';

const globalsService = {
    getAssetRoot() {
        return window.assetRoot;
    },

    getLibRoot() {
        return window.jsLibRoot ? window.jsLibRoot : 'https://d2snzxottmona5.cloudfront.net';
    },

    getDeployEnvironment() {
        return window.deployEnvironment;
    },

    getUploaderToken() {
        // todo implement proper csrf token
        return '';
    },

    /**
     * @returns {Array|string[]} Array of Inspera internal language codes. 'en_us' is the default.
     */
    getSupportedLanguages() {
        return window.supportedLanguages || ['en_us'];
    },

    getSupportedContentLanguages() {
        return window.supportedContentLanguages || ['en_us'];
    },

    getPlayerPrechecksInfo() {
        return window.playerPrechecksInfo || {};
    },

    isLocalhost() {
        return this.getDeployEnvironment() === 'local';
    },

    isProd() {
        return this.getDeployEnvironment() === 'prod';
    },

    isStage() {
        return this.getDeployEnvironment() === 'stage';
    },

    removePlayerLoader() {
        if (window.playerStartupConfig && window.playerStartupConfig.shouldUseNewLoader) {
            const preloaderContainer = document.getElementById(UIConstants.PLAYER_LOADER_SELECTOR_ID);
            if (preloaderContainer) {
                preloaderContainer.parentNode.removeChild(preloaderContainer);
            }
        }
    },

    setTestPlayerReady() {
        this.removePlayerLoader();
        window.testPlayerReady = true;
    },

    /**
     * This function setItemInLocalStorage safely writes a value to localStorage.
     *
     * This wrapper centralizes localStorage access to:
     * - gracefully handle environments where `window.localStorage` is unavailable
     *   (e.g., server-side rendering, private browsing modes, restricted iframes)
     * - provide a single location for future enhancements such as error handling,
     *   namespacing, encryption, or storage quotas.
     *
     * @param {string} key - The storage key for the value.
     * @param {string} value - The stringified value to store.
     *
     * @returns {void}
    */

    setItemInLocalStorage(key, value) {
        if (window.localStorage) {
            window.localStorage.setItem(key, value);
        }
    },

    /**
     * This function getItemFromLocalStorage safely retrieves a value from localStorage.
     *
     * This wrapper checks for the existence of `window.localStorage` before attempting
     * to read from it. This prevents runtime errors in environments where storage
     * is disabled or unsupported.
     *
     * @param {string} key - The key used to retrieve the stored value.
     *
     * @returns {string|null} The stored string value, or `null` if not found or if
     *                        localStorage is unavailable.
    */

    getItemFromLocalStorage(key) {
        if (window.localStorage) {
            return window.localStorage.getItem(key);
        }
        return null;
    },

    /**
     * This function removeItemFromLocalStorage safely removes an item from localStorage.
     *
     * This wrapper ensures that storage removal attempts occur only when
     * `window.localStorage` is accessible, preventing errors in restricted
     * or unsupported environments.
     *
     * @param {string} key - The key of the item to remove.
     *
     * @returns {void}
    */

    removeItemFromLocalStorage(key) {
        if (window.localStorage) {
            window.localStorage.removeItem(key);
        }
    },
};

export default globalsService;
